import React, { useContext } from 'react';
import Image from 'next/image';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AssessmentHeader = () => {
  const { xt } = useContext(i18nContext);
  const { assessment, metadata } = useContext(stepContext);
  const { css } = useContext(displayContext);

  return (
    <Row className={`${css('assessment-header')} ${css('assessment-padding-container')}`}>
      <Col>
        <h1 className={`${css('assessment-title')} my-2`}>{assessment.title}</h1>
        {metadata.header?.showAuthor && <h3>{assessment.author}</h3>}
        {metadata.header?.image && (
          <Image
            src={process.env.S3_ASSET_BUCKET + metadata.header.image.url}
            alt={xt(metadata.header.image.alt)}
            height={metadata.header.image.size?.height}
            width={metadata.header.image.size?.width}
          />
        )}
      </Col>
    </Row>
  );
};

export default AssessmentHeader;
